var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.MIX_getFromLocalStorage('currentSite'))?_c('app-text',{staticClass:"d-flex justify-center text-center mt-4",attrs:{"size":"xlarge"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }